// extracted by mini-css-extract-plugin
export default {"HeaderAuth":"HeaderAuth_HeaderAuth__3cK4T","HeaderTitle":"HeaderAuth_HeaderTitle__jR4FM","HeaderSubtitle":"HeaderAuth_HeaderSubtitle__uxW+T","SubTitle":"HeaderAuth_SubTitle__wPd1d"};